export default {
  articles: {
    "basetao-spreadsheet": {
      title: "Basetao Spreadsheet: o guia completo de produtos, vendedores, QC e envio",
      description:
        "Um guia completo do Basetao Spreadsheet — como ele organiza produtos, vendedores, fotos QC e detalhes de envio para você pesquisar mais rápido e comprar com mais confiança.",
      intro:
        "Um Basetao Spreadsheet é um documento estruturado e compartilhado que organiza produtos, vendedores, preços, fotos QC e detalhes de envio em um só lugar. Ele ajuda a encontrar itens mais rápido, comparar vendedores e acompanhar pedidos — muito mais fácil do que rolar mensagens dispersas.",
      sections: [
        {
          title: "O que é um Basetao Spreadsheet?",
          body: [
            "Um Basetao Spreadsheet é, essencialmente, uma tabela compartilhada que reúne tudo o que um comprador precisa para pesquisar uma compra. Em vez de vasculhar o histórico de chat, álbuns de vendedores ou favoritos, você encontra nomes de produtos, imagens, detalhes do vendedor, preços, status de QC e notas de envio em colunas claras.",
            "Essa organização é especialmente útil quando você compara muitos itens ao mesmo tempo. A planilha funciona como uma única fonte que você pode escanear rapidamente, economizando tempo e reduzindo o risco de confundir produtos parecidos de vendedores diferentes.",
          ],
        },
        {
          title: "Por que os compradores usam um Basetao Spreadsheet",
          body: [
            "O principal motivo é a velocidade. Quando a pesquisa é estruturada, você passa menos tempo procurando e mais tempo decidindo. Uma planilha também guarda um registro do que você encontrou, pediu e ainda precisa verificar.",
            "Para pedidos grandes ou compras repetidas, uma planilha ajuda a manter a consistência. Você acompanha vendedores de confiança, anota quais itens passaram no controle de qualidade e lembra opções de envio que funcionaram bem antes.",
          ],
        },
        {
          title: "Como um Basetao Spreadsheet é organizado",
          body: [
            "Uma planilha típica agrupa as informações em algumas colunas principais: nome do produto, imagem, categoria, vendedor, preço, status de QC e um link para o item. Algumas também incluem peso de envio, notas de armazém e observações pessoais.",
            "As categorias costumam refletir a estrutura da loja — tênis, moletons, camisetas, jaquetas, calças, acessórios de cabeça, conjuntos, roupas íntimas, camisas, acessórios, bolsas, cintos, perfumes e outros itens. Isso permite ir direto à seção de seu interesse.",
          ],
        },
        {
          title: "Como encontrar produtos com um Basetao Spreadsheet",
          body: [
            "Comece pela categoria de seu interesse e escaneie os nomes e imagens em busca de itens que combinem. Use as colunas de vendedor e preço para afunilar suas opções.",
            "Assim que notar um item promissor, abra o link no site principal para ver os detalhes completos, a disponibilidade e as ofertas atuais. A planilha é o ponto de partida — o anúncio em si é onde você confirma os detalhes.",
          ],
        },
        {
          title: "Como pesquisar vendedores",
          body: [
            "Pesquisar vendedores importa porque a qualidade e a confiabilidade variam. Observe se um vendedor aparece de forma consistente, como seus produtos são descritos e se notas de QC anteriores indicam problemas recorrentes.",
            "Trate as informações do vendedor como um primeiro sinal, não uma garantia. As condições mudam: verifique cada vendedor a cada pedido, especialmente em itens de maior valor.",
          ],
        },
        {
          title: "Entendendo as fotos QC",
          body: [
            "As fotos QC (controle de qualidade) são uma das partes mais valiosas do processo de compra. Elas mostram o item real antes do envio, para detectar cedo problemas de tamanho, cor ou defeito.",
            "Ao revisar fotos QC, compare-as com o anúncio original. Preste atenção em costuras, logotipos, cores e medidas. Se algo parecer estranho, pergunte antes de o item ser enviado.",
          ],
        },
        {
          title: "Custos e opções de envio",
          body: [
            "O custo de envio não é um número fixo — depende do peso do pacote, dimensões, país de destino, método escolhido e seguro. Pacotes mais pesados ou volumosos costumam custar mais.",
            "Diferentes linhas de envio equilibram velocidade e preço. Algumas são mais rápidas, porém mais caras, outras mais baratas, porém mais lentas. A escolha certa depende de quão rápido você precisa do pacote e de quanto quer gastar.",
          ],
        },
        {
          title: "Segurança e sinais de alerta",
          body: [
            "Mantenha uma precaução saudável. Desconfie de vendedores sem histórico, preços bons demais para ser verdade ou anúncios que reutilizam fotos sem relação. Pequenos depósitos ou pedidos de pagamento incomuns também podem ser sinais de alerta.",
            "Este site é um recurso independente: verifique sempre as informações por conta própria. Nenhum guia pode garantir qualidade do produto, confiabilidade do vendedor ou resultados de entrega. Use estes recursos como um ponto de partida útil, não como substituto do seu próprio julgamento.",
          ],
        },
      ],
      faqs: [
        {
          q: "Um Basetao Spreadsheet é gratuito?",
          a: "As planilhas costumam ser recursos compartilhados. Consulte o site principal para a versão atual e detalhes de acesso.",
        },
        {
          q: "Com que frequência a planilha é atualizada?",
          a: "As atualizações variam. Anúncios, vendedores e preços mudam: trate as informações como um instantâneo e confirme os detalhes antes de pedir.",
        },
        {
          q: "A planilha garante a qualidade do produto?",
          a: "Não. Ela organiza as informações, mas não pode garantir qualidade, confiabilidade do vendedor ou resultados de entrega. Revise sempre as fotos QC e faça suas próprias verificações.",
        },
      ],
      conclusion:
        "Um Basetao Spreadsheet é uma ferramenta prática para quem quer pesquisar produtos, vendedores, QC e envio de forma mais eficiente. Ele reúne informações dispersas em uma visão clara, para decisões melhores e menos tempo perdido procurando. Lembre-se de que os detalhes mudam: use a planilha como guia e confirme sempre as informações mais recentes no site principal antes de comprar.",
    },
    "basetao-review": {
      title: "Avaliação Basetao: recursos, envio, armazém e o que saber",
      description:
        "Uma avaliação honesta e independente da Basetao sobre como o agente de compras funciona, seus recursos de envio e armazém, prós e contras comuns e o que iniciantes devem saber antes de pedir.",
      intro:
        "A Basetao é um agente de compras usado há muito tempo que ajuda compradores internacionais a comprar produtos em plataformas chinesas e a armazená-los, verificá-los e enviá-los para o exterior. Esta avaliação explica como o serviço funciona, sem inventar notas ou estatísticas.",
      sections: [
        {
          title: "O que a Basetao faz",
          body: [
            "A Basetao atua como uma camada intermediária entre você e os vendedores dos mercados chineses. Você envia um link de produto, o agente faz o pedido por você e o item é entregue em um armazém, onde pode ser fotografado, verificado e guardado.",
            "Depois, você pode combinar vários itens em um pacote e enviá-los juntos. É uma das razões pelas quais muitos usam um agente: consolidar pedidos pequenos e inspecionar itens antes de saírem do país.",
          ],
        },
        {
          title: "Recursos principais",
          body: [
            "Os recursos principais incluem ajuda com pedidos, um armazém, fotos de controle de qualidade e várias opções de envio internacional. Cada um ajuda a controlar uma compra difícil de gerenciar do exterior.",
            "Como recursos e taxas mudam, trate qualquer lista como um instantâneo. A forma mais confiável de confirmar detalhes atuais é consultar diretamente o site principal.",
          ],
        },
        {
          title: "O que os compradores costumam valorizar",
          body: [
            "Muitos compradores internacionais valorizam a possibilidade de inspecionar itens com fotos QC antes do envio. Isso detecta cedo problemas de tamanho ou cor, quando ainda são fáceis de resolver.",
            "A consolidação é outro benefício citado com frequência. Reunir vários pedidos em um pacote torna o envio internacional mais prático, sobretudo para itens pequenos.",
          ],
        },
        {
          title: "Pontos a observar",
          body: [
            "O custo de envio pode se acumular, porque depende de peso, dimensões e destino. Um item barato pode ficar mais caro após a entrega internacional: estime o custo total antes de pedir.",
            "O suporte e os prazos de processamento podem variar conforme a demanda e a época. Se você tem um prazo rígido, deixe uma margem e acompanhe o status do pedido.",
          ],
        },
      ],
      faqs: [
        {
          q: "A Basetao é um serviço legítimo?",
          a: "A Basetao é um agente de compras usado há muito tempo por muitos compradores internacionais. Este site é independente: verifique sempre você mesmo vendedores e pedidos.",
        },
        {
          q: "Quais taxas devo esperar?",
          a: "Podem incluir o custo do item, a entrega local ao armazém, fotos QC opcionais, armazenamento e envio internacional. Consulte o site principal para preços atuais.",
        },
        {
          q: "A Basetao é adequada para iniciantes?",
          a: "O fluxo básico — enviar um link, receber itens no armazém, enviá-los — é acessível, mas informe-se antes sobre envio e QC para evitar surpresas.",
        },
      ],
      conclusion:
        "A Basetao oferece uma forma prática para compradores internacionais comprarem, inspecionarem e enviarem produtos de plataformas chinesas. Entender os custos de envio, o processo de armazém e as opções QC antes de pedir ajuda a tirar mais valor. Confirme sempre os detalhes atuais no site principal.",
    },
    "basetao-shipping-cost": {
      title: "Custo de envio Basetao: como o envio internacional é calculado",
      description:
        "Entenda o que determina o custo de envio Basetao — peso, dimensões, destino, método e seguro — e aprenda formas práticas de manter a entrega internacional acessível.",
      intro:
        "O custo de envio Basetao não é um número fixo. Ele é calculado a partir de várias variáveis, principalmente o peso e as dimensões do pacote, o país de destino, o método escolhido e o seguro. Conhecer esses fatores ajuda a estimar os custos antes de comprar.",
      sections: [
        {
          title: "Peso e peso volumétrico",
          body: [
            "O peso do pacote é o fator mais óbvio do custo de envio. Pacotes mais pesados custam mais, e cada item extra aumenta a conta.",
            "As linhas de envio costumam usar também o peso volumétrico, que considera o tamanho físico da caixa. Um item leve, mas volumoso, pode custar mais que um compacto e pesado.",
          ],
        },
        {
          title: "Destino e alfândega",
          body: [
            "O país de destino afeta tanto a tarifa quanto possíveis taxas locais. As regiões têm redes de entrega diferentes, e alguns destinos são simplesmente mais caros.",
            "A alfândega é uma consideração à parte da taxa de envio. Dependendo do país e do valor, você pode dever impostos de importação além do custo de entrega.",
          ],
        },
        {
          title: "Métodos e velocidade de envio",
          body: [
            "Linhas mais rápidas costumam custar mais, enquanto opções econômicas mais lentas são mais baratas. O equilíbrio está entre rapidez e orçamento.",
            "Alguns métodos incluem mais rastreamento ou melhor seguro por padrão. Compare além do preço para entender o que cada linha cobre.",
          ],
        },
        {
          title: "Como reduzir os custos",
          body: [
            "Consolidar vários itens em um pacote é uma das formas mais eficazes de reduzir o custo por item. Permite dividir a taxa base entre vários produtos.",
            "Escolher uma linha um pouco mais lenta, remover embalagens desnecessárias e planejar com antecedência também ajuda. A opção mais barata nem sempre é a melhor, mas entender suas prioridades esclarece a escolha.",
          ],
        },
      ],
      faqs: [
        {
          q: "Por que o envio é mais caro que o item?",
          a: "O envio internacional inclui a taxa da transportadora, que depende de peso, tamanho e distância. Um item pequeno e barato pode ter custo alto se for leve, mas volumoso, ou enviado sozinho.",
        },
        {
          q: "A Basetao cobra uma taxa fixa de envio?",
          a: "O envio costuma ser calculado por pacote conforme peso, dimensões e destino, não como taxa fixa. Consulte o site principal para preços atuais.",
        },
        {
          q: "Posso estimar o envio antes de comprar?",
          a: "Você terá uma ideia melhor quando os itens chegarem ao armazém e o peso real for conhecido. Planejamento e consolidação ajudam a estimar.",
        },
      ],
      conclusion:
        "O custo de envio Basetao depende de peso, dimensões, destino, método e seguro. Entendendo esses fatores e consolidando seus pedidos, você planeja um envio internacional mais acessível. Confirme sempre as tarifas mais recentes no site principal.",
    },
    "basetao-coupon": {
      title: "Guia de cupons Basetao: encontrar e verificar descontos atuais",
      description:
        "Um guia prático de cupons Basetao — os tipos de descontos, onde procurar ofertas atuais e como verificar um código para evitar promoções expiradas ou enganosas.",
      intro:
        "Cupons e promoções Basetao podem reduzir o custo do seu pedido, mas mudam com frequência e são fáceis de usar errado. Este guia explica os tipos comuns de desconto e como verificar se um código ainda está válido.",
      sections: [
        {
          title: "Tipos de descontos",
          body: [
            "Os descontos podem ter várias formas: uma porcentagem sobre taxas de serviço, um valor fixo sobre um pedido ou uma tarifa reduzida para novos usuários. Alguns focam no envio, outros na taxa de compra.",
            "Como as ofertas mudam, é melhor entender as categorias do que memorizar códigos específicos. Uma promoção do mês passado pode não estar ativa hoje.",
          ],
        },
        {
          title: "Onde procurar ofertas atuais",
          body: [
            "O site principal é o lugar mais confiável para ver promoções ativas. Anúncios ou boletins também podem mostrar ofertas por tempo limitado.",
            "Desconfie de códigos de sites de terceiros aleatórios. Costumam estar expirados, reciclados ou não verificados, criando uma falsa sensação de desconto.",
          ],
        },
        {
          title: "Como verificar um cupom",
          body: [
            "Antes de usar um código, verifique a data de validade e os requisitos de pedido mínimo. Um código pode valer apenas para certos tipos de pedido ou novos usuários.",
            "A forma mais limpa de verificar é aplicar o código no checkout e confirmar que o desconto aparece antes de pagar. Se for rejeitado ou não mudar o total, provavelmente está expirado.",
          ],
        },
        {
          title: "Evitar armadilhas com cupons",
          body: [
            "Não persiga um desconto à custa do produto ou método de envio adequados. Uma pequena economia raramente vale um pedido arriscado.",
            "Trate qualquer promessa de grande desconto com ceticismo. Se uma oferta parece boa demais ou pede etapas incomuns, melhor ignorá-la e ficar com as promoções do site oficial.",
          ],
        },
      ],
      faqs: [
        {
          q: "Onde encontro cupons ativos da Basetao?",
          a: "O site principal é a fonte mais confiável de promoções atuais. As ofertas mudam: procure códigos lá em vez de sites de terceiros.",
        },
        {
          q: "Os cupons Basetao expiram?",
          a: "A maioria tem data de validade ou fica disponível por tempo limitado. Verifique sempre as condições antes de usar.",
        },
        {
          q: "Posso combinar vários cupons?",
          a: "Normalmente só uma promoção vale por pedido, mas as regras variam. Consulte as condições no site principal.",
        },
      ],
      conclusion:
        "Cupons Basetao são úteis, mas apenas quando estão atuais e aplicados corretamente. Confie nas ofertas do site oficial, verifique um código no checkout e evite códigos de terceiros bons demais para ser verdade. Assim sua economia é real e simples.",
    },
    "basetao-discount-code": {
      title: "Código de desconto Basetao: guia para iniciantes usarem códigos com segurança",
      description:
        "Aprenda como os códigos de desconto Basetao funcionam, a diferença entre um código e um cupom geral, como funcionam os códigos de novos usuários e como evitar códigos expirados.",
      intro:
        "Um código de desconto Basetao é uma sequência de texto específica que desbloqueia uma promoção no checkout. Entender como esses códigos funcionam — e como diferem dos descontos gerais — ajuda a usá-los corretamente.",
      sections: [
        {
          title: "O que é um código de desconto",
          body: [
            "Um código de desconto costuma ser uma combinação curta de letras e números que você digita no checkout para reduzir uma taxa ou total. Diferente de uma venda geral, o desconto está ligado a esse código.",
            "Os códigos costumam estar sujeitos a condições, como valor mínimo, requisito de primeiro pedido ou prazo limitado. Ler essas condições antes de aplicar evita decepções.",
          ],
        },
        {
          title: "Códigos de novos usuários e primeiro pedido",
          body: [
            "Algumas plataformas oferecem desconto de boas-vindas ou tarifa reduzida no primeiro pedido. É uma forma comum de experimentar um serviço por um custo menor.",
            "Códigos de novos usuários quase sempre têm restrições, como uso único. Se você já pediu antes, um código de primeiro pedido provavelmente não se aplicará.",
          ],
        },
        {
          title: "Aplicar um código corretamente",
          body: [
            "Digite o código exatamente como fornecido, sem espaços, e aplique antes de concluir o pagamento. O checkout deve atualizar o total imediatamente se o código for válido.",
            "Se o total não mudar ou aparecer um erro, o código provavelmente está expirado, já usado ou não é válido para seu pedido. Não siga assumindo que o desconto será aplicado depois.",
          ],
        },
        {
          title: "Detectar códigos falsos ou expirados",
          body: [
            "Desconfie de códigos compartilhados em fóruns ou redes sem fonte clara. Muitos são reciclados de promoções antigas e simplesmente rejeitados.",
            "Um desconto legítimo deve vir do site oficial ou de uma comunicação oficial. Se um código for promovido com linguagem urgente ou exagerada, trate-o com cautela.",
          ],
        },
      ],
      faqs: [
        {
          q: "Qual a diferença entre cupom e código de desconto?",
          a: "Os termos costumam ser usados como sinônimos. Um código é uma sequência específica digitada no checkout, enquanto um cupom pode se referir à promoção em si.",
        },
        {
          q: "Códigos de primeiro pedido funcionam para clientes existentes?",
          a: "Geralmente não. São feitos para novos usuários e limitados ao primeiro pedido.",
        },
        {
          q: "Por que meu código de desconto não funciona?",
          a: "Pode estar expirado, já usado, digitado errado ou não ser válido para seu pedido. Verifique as condições e tente de novo antes de pagar.",
        },
      ],
      conclusion:
        "Códigos de desconto Basetao podem dar uma economia real quando estão atuais e aplicados corretamente. Use códigos do site oficial, verifique as condições e confirme o desconto no checkout antes de pagar. Esse hábito protege você de ofertas expiradas ou enganosas.",
    },
    "basetao-warehouse": {
      title: "Guia do armazém Basetao: armazenamento, QC, inspeção e envio",
      description:
        "Entenda como o armazém Basetao funciona — armazenamento, fotos QC e inspeção, consolidação e a conexão com o envio internacional.",
      intro:
        "O armazém Basetao é onde seus itens comprados são recebidos, guardados e verificados antes do envio internacional. Entender essa etapa ajuda a planejar a consolidação, pedir fotos QC e evitar surpresas.",
      sections: [
        {
          title: "Como o armazém funciona",
          body: [
            "Quando você pede pelo agente, o vendedor envia seu item a um armazém em vez de diretamente a você. O armazém registra a chegada e guarda o item até você decidir.",
            "Essa etapa intermediária torna a consolidação possível. Em vez de enviar cada item ao chegar, você pode esperar vários e enviá-los como um pacote.",
          ],
        },
        {
          title: "Armazenamento e consolidação",
          body: [
            "O armazém pode guardar seus itens por um tempo, dando flexibilidade para reunir um pedido maior. A consolidação combina vários itens em uma caixa.",
            "Consolidar pode reduzir o custo de envio por item, mas aumenta o peso total. Entender esse equilíbrio ajuda a decidir quantos itens agrupar.",
          ],
        },
        {
          title: "Fotos QC e inspeção",
          body: [
            "Antes do envio, você costuma poder pedir fotos de controle de qualidade que mostram o item real recebido. Elas ajudam a revisar tamanho, cor ou defeitos enquanto ainda é fácil trocar.",
            "Inspecionar fotos QC é um dos hábitos mais valiosos. Compare-as com o anúncio original e levante dúvidas antes de o item sair do armazém.",
          ],
        },
        {
          title: "Taxas e prazos do armazém",
          body: [
            "O armazenamento pode ser gratuito por um período, com taxas se for excedido. A política varia: consulte o site principal para as condições atuais.",
            "O tempo de processamento pode variar conforme a demanda. Se você tem um prazo, peça QC e organize o envio cedo.",
          ],
        },
      ],
      faqs: [
        {
          q: "Quanto tempo os itens podem ficar no armazém?",
          a: "O armazenamento costuma ser gratuito por um período limitado, após o qual taxas podem ser aplicadas. Consulte a política atual no site principal.",
        },
        {
          q: "O que são fotos QC?",
          a: "Imagens do seu item real tiradas no armazém antes do envio, para revisar problemas enquanto ainda é fácil resolvê-los.",
        },
        {
          q: "Devo consolidar todos os meus itens?",
          a: "Consolidar pode reduzir o custo por item, mas aumenta o peso. Pondere rapidez, custo e tamanho antes de decidir.",
        },
      ],
      conclusion:
        "O armazém Basetao é uma parte essencial do processo de compra, permitindo armazenamento, inspeção QC e consolidação antes do envio. Entender como funciona ajuda a planejar um pedido mais fluido e econômico. Confirme sempre os detalhes de armazenamento e taxas no site principal.",
    },
    "basetao-legit": {
      title: "A Basetao é legítima? Segurança, QC, envio e guia de pesquisa",
      description:
        "Uma visão clara sobre se a Basetao é legítima e segura — como o agente funciona, quais sinais de alerta observar e como pesquisar vendedores e pedidos de forma responsável.",
      intro:
        "A Basetao é um agente de compras usado há muito tempo por muitos compradores internacionais para comprar e enviar produtos de plataformas chinesas. Esta página é um recurso independente: explica como avaliar legitimidade e segurança por conta própria.",
      sections: [
        {
          title: "O que torna um agente de compras legítimo",
          body: [
            "Um agente legítimo realmente faz pedidos, armazena e envia itens, com um processo claro. Longevidade e um fluxo transparente são melhores sinais do que marketing chamativo.",
            "Como este site é independente, ele não afirma ser afiliado ou endossado pela Basetao. O mais seguro é avaliar o serviço com suas próprias observações e informações atuais.",
          ],
        },
        {
          title: "Pesquisar antes de comprar",
          body: [
            "Comece pequeno. Um pedido de teste de baixo valor é uma forma comum de conhecer um serviço sem arriscar muito. Observe a comunicação, os prazos e como os problemas são tratados.",
            "Leia a documentação disponível no site principal, como políticas de envio, armazenamento e QC. Informações claras e atuais são um sinal positivo.",
          ],
        },
        {
          title: "Sinais de alerta comuns",
          body: [
            "Desconfie de vendedores sem histórico, preços bons demais ou anúncios que reutilizam fotos sem relação. Pedidos de pagamento incomuns ou pressão para agir rápido também são sinais.",
            "Nenhum guia pode garantir a qualidade do produto ou a confiabilidade do vendedor. Trate cada pedido como algo que você verifica por conta própria, com fotos QC e seu julgamento.",
          ],
        },
        {
          title: "Manter-se seguro durante o processo",
          body: [
            "Revise as fotos QC com cuidado antes do envio, guarde registros dos seus pedidos e confirme os custos antes de se comprometer. Esses hábitos reduzem surpresas.",
            "Lembre-se de que custos de envio, vendedores e promoções mudam. Use os recursos deste site como ponto de partida, não como substituto de conferir no site principal.",
          ],
        },
      ],
      faqs: [
        {
          q: "A Basetao é segura de usar?",
          a: "A Basetao é um agente de compras usado há muito tempo por muitos compradores internacionais. Como em qualquer serviço, verifique você mesmo vendedores e pedidos e revise as fotos QC antes do envio.",
        },
        {
          q: "Este site é afiliado à Basetao?",
          a: "Não. É um recurso informativo independente, não afiliado nem endossado pela Basetao.",
        },
        {
          q: "Como reduzo o risco ao pedir?",
          a: "Comece com um pedido pequeno, pesquise os vendedores, revise as fotos QC e confirme os custos antes de se comprometer.",
        },
      ],
      conclusion:
        "A Basetao é um agente de compras de longa trajetória com um processo estruturado de compra, armazenamento e envio. Se ela é certa para você depende da sua própria pesquisa: comece pequeno, revise as fotos QC e confirme os custos. Este site independente ajuda a entender o processo sem fazer promessas.",
    },
    "basetao-qc": {
      title: "Guia QC Basetao: como revisar as fotos de controle de qualidade",
      description:
        "Aprenda como as fotos QC Basetao funcionam, o que observar ao revisá-las, como compará-las com o anúncio original e como levantar problemas antes do envio.",
      intro:
        "As fotos QC (controle de qualidade) mostram o item real recebido antes do envio internacional. Revisá-las com cuidado é uma das formas mais eficazes de detectar problemas de tamanho, cor ou defeito enquanto ainda são fáceis de resolver.",
      sections: [
        {
          title: "O que as fotos QC mostram",
          body: [
            "As fotos QC são imagens do seu item real tiradas no armazém, não as fotos promocionais do vendedor. Elas mostram o que você realmente recebeu para confirmar que corresponde às expectativas.",
            "Dependendo do serviço, as fotos podem cobrir o item completo, as etiquetas ou detalhes como costuras e logotipos. Saber o que pedir ajuda a obter imagens mais úteis.",
          ],
        },
        {
          title: "Como revisar as fotos QC",
          body: [
            "Compare cada foto QC com o anúncio original. Procure diferenças de cor, tamanho, costuras, logotipos e materiais, e verifique se o item corresponde à descrição.",
            "Preste atenção a detalhes difíceis de verificar de longe, como qualidade de impressão, costuras e medidas. Se uma foto não estiver clara, peça uma mais próxima antes do envio.",
          ],
        },
        {
          title: "O que verificar",
          body: [
            "Verifique o tamanho com as medidas de que você precisa, pois uma discrepância é um problema comum. Confirme as cores, porque a luz das fotos pode enganar.",
            "Procure defeitos visíveis como fios soltos, impressões desalinhadas, arranhões ou manchas. Detectá-los cedo é muito mais fácil do que resolver após o envio.",
          ],
        },
        {
          title: "Levantar problemas antes do envio",
          body: [
            "Se você notar um problema em uma foto QC, comunique ao agente antes do envio. É o momento em que trocas ou reembolsos são mais simples.",
            "Seja específico sobre o que vê e o que quer, e guarde registros. Uma comunicação clara nessa etapa economiza tempo e dinheiro.",
          ],
        },
      ],
      faqs: [
        {
          q: "As fotos QC estão sempre incluídas?",
          a: "Podem ser opcionais ou incluídas conforme o pedido. Consulte o site principal para confirmar o que é oferecido e possíveis custos.",
        },
        {
          q: "E se a foto QC mostrar um defeito?",
          a: "Comunique o problema antes do envio. Costuma ser o momento mais fácil para organizar uma troca ou reembolso.",
        },
        {
          q: "Posso pedir fotos QC adicionais?",
          a: "Em muitos casos você pode pedir fotos mais próximas. Confirme o processo e as taxas no site principal.",
        },
      ],
      conclusion:
        "Revisar as fotos QC Basetao é uma das melhores formas de se proteger como comprador internacional. Compare as fotos com o anúncio, verifique tamanho e detalhes e comunique qualquer problema antes do envio. Essa disciplina simples evita surpresas caras.",
    },
    "basetao-sellers": {
      title: "Guia de vendedores Basetao: pesquisar e comparar vendedores",
      description:
        "Um guia prático para pesquisar vendedores Basetao — o que observar, como avaliar o histórico e os anúncios, e como detectar sinais de alerta antes de pedir.",
      intro:
        "Pesquisar vendedores é uma das partes mais importantes de comprar por meio de um agente, porque a qualidade e a confiabilidade variam. Este guia explica o que verificar para decidir com mais critério.",
      sections: [
        {
          title: "Por que pesquisar vendedores importa",
          body: [
            "Mesmo quando um agente gerencia o pedido, o vendedor determina a qualidade do produto. Um vendedor confiável tem mais chances de enviar um item que corresponde ao anúncio.",
            "Pesquisar vendedores evita tamanhos errados, materiais ruins ou itens que não chegam como descritos. Um pouco de tempo de verificação evita muita frustração.",
          ],
        },
        {
          title: "O que observar em um vendedor",
          body: [
            "Observe se um vendedor aparece de forma consistente e como seus produtos são descritos. Anúncios detalhados e coerentes são melhor sinal do que conteúdo vago ou reciclado.",
            "Revise o histórico ou feedback disponível e anote problemas recorrentes. Padrões importam mais do que um dado isolado.",
          ],
        },
        {
          title: "Usar fotos QC para avaliar vendedores",
          body: [
            "As fotos QC mostram a qualidade real que um vendedor entrega, não apenas o que o anúncio promete. Se os itens dele nunca correspondem às fotos, é um sinal claro.",
            "Anote quais vendedores atenderam às suas expectativas e quais não. Com o tempo, isso cria uma referência pessoal para pedidos futuros.",
          ],
        },
        {
          title: "Sinais de alerta a evitar",
          body: [
            "Desconfie de vendedores sem histórico, preços anormalmente baixos ou anúncios que reutilizam imagens sem relação. Pressão para comprar rápido ou pedidos de pagamento incomuns também são motivos para pausar.",
            "Nenhuma pesquisa garante um pedido perfeito. Trate suas conclusões como sinais para decidir e revise sempre as fotos QC antes do envio.",
          ],
        },
      ],
      faqs: [
        {
          q: "Como avalio um vendedor Basetao?",
          a: "Verifique a coerência dos anúncios, o histórico ou feedback disponível e compare as fotos QC com o anúncio original.",
        },
        {
          q: "O que é um sinal de alerta ao escolher vendedor?",
          a: "Pouco histórico, preços bons demais, fotos recicladas e pressão para agir rápido são sinais comuns.",
        },
        {
          q: "Posso confiar totalmente nas avaliações?",
          a: "As avaliações são um sinal útil, mas não uma garantia. Combine-as com seu próprio exame de anúncios e fotos QC.",
        },
      ],
      conclusion:
        "Pesquisar vendedores Basetao ajuda a evitar itens de baixa qualidade e torna a compra mais fluida. Verifique a coerência dos anúncios, use as fotos QC e fique atento aos sinais de alerta. Suas anotações se tornam, com o tempo, uma referência valiosa.",
    },
    "basetao-products": {
      title: "Guia de produtos Basetao: o que comprar e como encontrar os melhores itens",
      description:
        "Descubra as categorias de produtos Basetao mais populares — de tênis e moletons a bolsas e acessórios — e como encontrar itens bem avaliados que combinem com você.",
      intro:
        "A Basetao é muito usada para comprar uma ampla gama de produtos de moda e estilo de vida em plataformas chinesas. Este guia apresenta as categorias principais e como encontrar itens que combinem com suas necessidades e orçamento.",
      sections: [
        {
          title: "Categorias populares",
          body: [
            "As categorias comuns incluem tênis, moletons, camisetas, jaquetas, calças, acessórios de cabeça, conjuntos, roupas íntimas, camisas, acessórios, bolsas, cintos e perfumes. Cada uma tem seus estilos e preços.",
            "Saber qual categoria você quer acelera a pesquisa. Em vez de navegar por tudo, vá direto à seção que corresponde ao que procura.",
          ],
        },
        {
          title: "Encontrar itens bem avaliados",
          body: [
            "Comece com uma ideia clara do que quer e procure itens com anúncios detalhados e fotos nítidas. Quanto mais específica a descrição, mais fácil julgar a qualidade.",
            "Use as fotos QC e a pesquisa do vendedor juntas. Um anúncio promissor é só metade: o item real e o vendedor importam igualmente.",
          ],
        },
        {
          title: "Ajustar os produtos às suas necessidades",
          body: [
            "Cuide dos tamanhos, sobretudo em roupas e calçados, pois devoluções internacionais são mais difíceis. Verifique as medidas com o que você já possui.",
            "Pense em como o item se encaixa no seu guarda-roupa ou dia a dia. Um item da moda que você não usará raramente é uma boa compra.",
          ],
        },
        {
          title: "Orçamento e envio",
          body: [
            "Lembre-se de que o preço do item é só uma parte do custo total. O envio internacional, possíveis impostos e serviços opcionais se somam.",
            "Planeje seus pedidos para consolidar vários itens quando fizer sentido. Isso pode tornar o custo efetivo de cada produto mais razoável.",
          ],
        },
      ],
      faqs: [
        {
          q: "Quais são as categorias Basetao mais populares?",
          a: "Tênis, moletons, camisetas, jaquetas, bolsas e acessórios estão entre as mais comuns. A categoria certa depende do seu gosto.",
        },
        {
          q: "Como encontro produtos de qualidade?",
          a: "Procure anúncios detalhados, revise as fotos QC e pesquise o vendedor. Combinar esses passos dá uma ideia muito melhor da qualidade real.",
        },
        {
          q: "Devo pensar no envio antes de comprar?",
          a: "Sim. O preço do item é só uma parte do custo: estime o envio e possíveis impostos antes de se comprometer.",
        },
      ],
      conclusion:
        "Comprar produtos Basetao é mais gratificante quando você sabe o que quer, pesquisa o anúncio e o vendedor e considera o custo total. Focando nas categorias certas e revisando as fotos QC, você encontra itens que realmente combinam com suas necessidades.",
    },
  },
};